// The request `_app.tsx` fires on every page load to keep the per-request /blog render warm. The
// header tells the locale middleware not to redirect, so the warm-up hits the same route the first
// reader will.
//
// The response is discarded by design, and so is the failure: a mobile network drop or a navigation
// that aborts the request in flight rejects with `TypeError: Failed to fetch`; nobody awaits the
// promise, so an uncaught rejection would surface as `unhandledrejection`, which posthog-js
// autocaptures as an unhandled error on whatever page the visitor is on. There is nothing to retry
// or report; the first real reader simply pays the cold /blog render, as they would with no warm-up.
export function warmBlogCache(): Promise<void> {
  return fetch('/blog', {
    headers: {
      'x-no-locale-redirect': '1',
    },
  }).then(
    () => undefined,
    () => undefined
  );
}
